import { EventCatalogFromKeys, EventType } from "../types";

export const PublicEventKeys = {
  PUBLIC_404_PAGE_VIEW: "public-404-page-view",
  PUBLIC_ABOUT_PAGE_VIEW: "public-about-page-view",
  PUBLIC_AVAILABLE_NEEDS_PAGE_VIEW: "public-available-needs-page-view",
  PUBLIC_CAFO_PAGE_VIEW: "public-cafo-page-view",
  PUBLIC_CONTACT_FORM_SUBMIT_ATTEMPT: "public-contact-form-submit-attempt",
  PUBLIC_CONTACT_FORM_SUBMIT_FAILURE: "public-contact-form-submit-failure",
  PUBLIC_CONTACT_FORM_SUBMIT_SUCCESS: "public-contact-form-submit-success",
  PUBLIC_CONTACT_PAGE_VIEW: "public-contact-page-view",
  PUBLIC_DOCS_HOME_PAGE_VIEW: "public-docs-home-page-view",
  PUBLIC_DOCS_SINGLE_PAGE_VIEW: "public-docs-single-page-view",
  PUBLIC_EMAIL_DEMO_TEMPLATE_PAGE_VIEW: "public-email-demo-template-page-view",
  PUBLIC_EMAIL_DEMOS_PAGE_VIEW: "public-email-demos-page-view",
  PUBLIC_FEATURES_PAGE_VIEW: "public-features-page-view",
  PUBLIC_FORGOT_PASSWORD_PAGE_VIEW: "public-forgot-password-page-view",
  PUBLIC_GET_STARTED_BUTTON_CLICK: "public-get-started-button-click",
  PUBLIC_HOMEPAGE_VIEW: "public-homepage-view",
  PUBLIC_HOW_IT_WORKS_PAGE_VIEW: "public-how-it-works-page-view",
  PUBLIC_LOGIN_PAGE_VIEW: "public-login-page-view",
  PUBLIC_PRICING_PAGE_VIEW: "public-pricing-page-view",
  PUBLIC_REGISTER_PAGE_VIEW: "public-register-page-view",
  PUBLIC_REGISTRATION_SUBMITTED_PAGE_VIEW:
    "public-registration-submitted-page-view",
  PUBLIC_RESEND_VERIFICATION_FORM_SUBMIT_ATTEMPT:
    "public-resend-verification-form-submit-attempt",
  PUBLIC_RESEND_VERIFICATION_FORM_SUBMIT_FAILURE:
    "public-resend-verification-form-submit-failure",
  PUBLIC_RESEND_VERIFICATION_FORM_SUBMIT_SUCCESS:
    "public-resend-verification-form-submit-success",
  PUBLIC_RESEND_VERIFICATION_PAGE_VIEW: "public-resend-verification-page-view",
  PUBLIC_RESET_PASSWORD_PAGE_VIEW: "public-reset-password-page-view",
  PUBLIC_SEE_HOW_IT_WORKS_BUTTON_CLICK: "public-see-how-it-works-button-click",
  PUBLIC_SIGN_IN_BUTTON_CLICK: "public-sign-in-button-click",
  PUBLIC_USE_CASES_PAGE_VIEW: "public-use-cases-page-view",
  PUBLIC_VERIFY_EMAIL_PAGE_VIEW: "public-verify-email-page-view",
  PUBLIC_VIEW_NEEDS_BUTTON_CLICK: "public-view-needs-button-click",
} as const;

export const PublicEventCatalog: EventCatalogFromKeys<typeof PublicEventKeys> =
  {
    [PublicEventKeys.PUBLIC_404_PAGE_VIEW]: {
      description: "Public user viewed a 404 not found page",
      eventType: EventType.PAGE_VIEW,
      id: PublicEventKeys.PUBLIC_404_PAGE_VIEW,
    },
    [PublicEventKeys.PUBLIC_ABOUT_PAGE_VIEW]: {
      description: "Public user viewed the about page",
      eventType: EventType.PAGE_VIEW,
      id: PublicEventKeys.PUBLIC_ABOUT_PAGE_VIEW,
    },
    [PublicEventKeys.PUBLIC_CONTACT_FORM_SUBMIT_ATTEMPT]: {
      description: "Public user attempted to submit the contact form",
      eventType: EventType.FORM_SUBMISSION,
      id: PublicEventKeys.PUBLIC_CONTACT_FORM_SUBMIT_ATTEMPT,
    },
    [PublicEventKeys.PUBLIC_CONTACT_FORM_SUBMIT_FAILURE]: {
      description: "Public user failed to submit the contact form",
      eventType: EventType.ERROR,
      id: PublicEventKeys.PUBLIC_CONTACT_FORM_SUBMIT_FAILURE,
    },
    [PublicEventKeys.PUBLIC_CONTACT_FORM_SUBMIT_SUCCESS]: {
      description: "Public user successfully submitted the contact form",
      eventType: EventType.FORM_SUBMISSION,
      id: PublicEventKeys.PUBLIC_CONTACT_FORM_SUBMIT_SUCCESS,
    },
    [PublicEventKeys.PUBLIC_CONTACT_PAGE_VIEW]: {
      description: "Public user viewed the contact page",
      eventType: EventType.PAGE_VIEW,
      id: PublicEventKeys.PUBLIC_CONTACT_PAGE_VIEW,
    },

    [PublicEventKeys.PUBLIC_FEATURES_PAGE_VIEW]: {
      description: "Public user viewed the features page",
      eventType: EventType.PAGE_VIEW,
      id: PublicEventKeys.PUBLIC_FEATURES_PAGE_VIEW,
    },

    [PublicEventKeys.PUBLIC_FORGOT_PASSWORD_PAGE_VIEW]: {
      description: "Public user viewed the forgot password page",
      eventType: EventType.PAGE_VIEW,
      id: PublicEventKeys.PUBLIC_FORGOT_PASSWORD_PAGE_VIEW,
    },
    [PublicEventKeys.PUBLIC_GET_STARTED_BUTTON_CLICK]: {
      description: "Public user clicked the get started button",
      eventType: EventType.BUTTON_CLICK,
      id: PublicEventKeys.PUBLIC_GET_STARTED_BUTTON_CLICK,
    },
    [PublicEventKeys.PUBLIC_HOMEPAGE_VIEW]: {
      description: "Public user viewed the homepage",
      eventType: EventType.PAGE_VIEW,
      id: PublicEventKeys.PUBLIC_HOMEPAGE_VIEW,
    },
    [PublicEventKeys.PUBLIC_HOW_IT_WORKS_PAGE_VIEW]: {
      description: "Public user viewed the how it works page",
      eventType: EventType.PAGE_VIEW,
      id: PublicEventKeys.PUBLIC_HOW_IT_WORKS_PAGE_VIEW,
    },
    [PublicEventKeys.PUBLIC_LOGIN_PAGE_VIEW]: {
      description: "Public user viewed the login page",
      eventType: EventType.PAGE_VIEW,
      id: PublicEventKeys.PUBLIC_LOGIN_PAGE_VIEW,
    },
    [PublicEventKeys.PUBLIC_PRICING_PAGE_VIEW]: {
      description: "Public user viewed the pricing page",
      eventType: EventType.PAGE_VIEW,
      id: PublicEventKeys.PUBLIC_PRICING_PAGE_VIEW,
    },
    [PublicEventKeys.PUBLIC_REGISTER_PAGE_VIEW]: {
      description: "Public user viewed the register page",
      eventType: EventType.PAGE_VIEW,
      id: PublicEventKeys.PUBLIC_REGISTER_PAGE_VIEW,
    },
    [PublicEventKeys.PUBLIC_REGISTRATION_SUBMITTED_PAGE_VIEW]: {
      description: "Public user viewed the registration submitted page",
      eventType: EventType.PAGE_VIEW,
      id: PublicEventKeys.PUBLIC_REGISTRATION_SUBMITTED_PAGE_VIEW,
    },
    [PublicEventKeys.PUBLIC_RESEND_VERIFICATION_FORM_SUBMIT_ATTEMPT]: {
      description:
        "Public user attempted to submit the resend verification form",
      eventType: EventType.FORM_SUBMISSION,
      id: PublicEventKeys.PUBLIC_RESEND_VERIFICATION_FORM_SUBMIT_ATTEMPT,
    },
    [PublicEventKeys.PUBLIC_RESEND_VERIFICATION_FORM_SUBMIT_FAILURE]: {
      description: "Public user failed to submit the resend verification form",
      eventType: EventType.ERROR,
      id: PublicEventKeys.PUBLIC_RESEND_VERIFICATION_FORM_SUBMIT_FAILURE,
    },
    [PublicEventKeys.PUBLIC_RESEND_VERIFICATION_FORM_SUBMIT_SUCCESS]: {
      description:
        "Public user successfully submitted the resend verification form",
      eventType: EventType.FORM_SUBMISSION,
      id: PublicEventKeys.PUBLIC_RESEND_VERIFICATION_FORM_SUBMIT_SUCCESS,
    },
    [PublicEventKeys.PUBLIC_RESEND_VERIFICATION_PAGE_VIEW]: {
      description: "Public user viewed the resend verification page",
      eventType: EventType.PAGE_VIEW,
      id: PublicEventKeys.PUBLIC_RESEND_VERIFICATION_PAGE_VIEW,
    },
    [PublicEventKeys.PUBLIC_RESET_PASSWORD_PAGE_VIEW]: {
      description: "Public user viewed the reset password page",
      eventType: EventType.PAGE_VIEW,
      id: PublicEventKeys.PUBLIC_RESET_PASSWORD_PAGE_VIEW,
    },
    [PublicEventKeys.PUBLIC_SEE_HOW_IT_WORKS_BUTTON_CLICK]: {
      description: "Public user clicked the see how it works button",
      eventType: EventType.BUTTON_CLICK,
      id: PublicEventKeys.PUBLIC_SEE_HOW_IT_WORKS_BUTTON_CLICK,
    },
    [PublicEventKeys.PUBLIC_SIGN_IN_BUTTON_CLICK]: {
      description: "Public user clicked the sign in button",
      eventType: EventType.BUTTON_CLICK,
      id: PublicEventKeys.PUBLIC_SIGN_IN_BUTTON_CLICK,
    },
    [PublicEventKeys.PUBLIC_USE_CASES_PAGE_VIEW]: {
      description: "Public user viewed the use cases page",
      eventType: EventType.PAGE_VIEW,
      id: PublicEventKeys.PUBLIC_USE_CASES_PAGE_VIEW,
    },
    [PublicEventKeys.PUBLIC_VERIFY_EMAIL_PAGE_VIEW]: {
      description: "Public user viewed the verify email page",
      eventType: EventType.PAGE_VIEW,
      id: PublicEventKeys.PUBLIC_VERIFY_EMAIL_PAGE_VIEW,
    },
    [PublicEventKeys.PUBLIC_VIEW_NEEDS_BUTTON_CLICK]: {
      description: "Public user clicked the view needs button",
      eventType: EventType.BUTTON_CLICK,
      id: PublicEventKeys.PUBLIC_VIEW_NEEDS_BUTTON_CLICK,
    },
    [PublicEventKeys.PUBLIC_DOCS_HOME_PAGE_VIEW]: {
      description: "Public user viewed the docs home page",
      eventType: EventType.PAGE_VIEW,
      id: PublicEventKeys.PUBLIC_DOCS_HOME_PAGE_VIEW,
    },
    [PublicEventKeys.PUBLIC_DOCS_SINGLE_PAGE_VIEW]: {
      description: "Public user viewed a single docs page",
      eventType: EventType.PAGE_VIEW,
      id: PublicEventKeys.PUBLIC_DOCS_SINGLE_PAGE_VIEW,
    },
    [PublicEventKeys.PUBLIC_EMAIL_DEMO_TEMPLATE_PAGE_VIEW]: {
      description: "Public user viewed an email demo template page",
      eventType: EventType.PAGE_VIEW,
      id: PublicEventKeys.PUBLIC_EMAIL_DEMO_TEMPLATE_PAGE_VIEW,
    },
    [PublicEventKeys.PUBLIC_EMAIL_DEMOS_PAGE_VIEW]: {
      description: "Public user viewed the email demos page",
      eventType: EventType.PAGE_VIEW,
      id: PublicEventKeys.PUBLIC_EMAIL_DEMOS_PAGE_VIEW,
    },
    [PublicEventKeys.PUBLIC_AVAILABLE_NEEDS_PAGE_VIEW]: {
      description: "Public user viewed the available needs page",
      eventType: EventType.PAGE_VIEW,
      id: PublicEventKeys.PUBLIC_AVAILABLE_NEEDS_PAGE_VIEW,
    },
    [PublicEventKeys.PUBLIC_CAFO_PAGE_VIEW]: {
      description: "Public user viewed the CAFO landing page",
      eventType: EventType.PAGE_VIEW,
      id: PublicEventKeys.PUBLIC_CAFO_PAGE_VIEW,
    },
  };
